module.exports = __webpack_public_path__ + "img/logo_white.780ce045.svg";